export default __webpack_public_path__ + "static/media/sms.df3e73a0.svg";